import LZ from 'lzutf8';
import QS from 'query-string';
const decodeQuery = location => {
  const rtn = {};
  const params = QS.parse(location.search);
  try {
    if (params.f) {
      const f = LZ.decompress(LZ.decodeBase64(params.f));
      rtn.filters = JSON.parse(f);
    }
  } catch (err) {
    console.error(err);
  }
  rtn.limit = Number(params.limit) || 100;
  rtn.page = Number(params.page) || 0;
  rtn.perPage = Number(params.perPage) || 0;
  return {
    ...params,
    ...rtn
  };
};
const encodeQuery = ({
  limit,
  page,
  filters,
  ...rest
}) => {
  const q = {
    ...rest
  };
  if (typeof limit === 'number') {
    q.limit = limit;
  }
  if (typeof page === 'number') {
    q.page = page;
  }
  if (filters) {
    try {
      q.f = LZ.encodeBase64(LZ.compress(JSON.stringify(filters)));
    } catch (err) {
      console.error(err);
    }
  }
  return QS.stringify(q);
};
export default {
  decodeQuery,
  encodeQuery
};